import React, { Component } from "react"
import { Modal, Form, 
	// Select, 
	Input, Button } from "antd"
import { toast } from "react-toastify"
// import { connect } from "react-redux"
// import { editQuestion } from "../services/Api"
// import { withRouter } from "react-router-dom"

toast.configure({
    position: "bottom-right"
})

// const KIDS_TOKEN = "kids_access_token"
// const { Option } = Select

class EditModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			signInState: false,
			question: "",
		}
	}

	componentDidMount() {}
	formRef = React.createRef()
	render() {
		const {
			visible,
			onCancel,
			onCreate,
			formRef,
			// onSignUpClick,
		} = this.props

		return (
			<React.Fragment>
				<Modal
					className='login_block'
					visible={visible}
					okText='Recover'
					onCancel={onCancel}
					onOk={onCreate}
					footer={null}
				>
					<div className='modalPayment'>
						<div className='loginForm'>
							<Form
								initialValues={{ inputname: this.props.name }}
								ref={formRef}
								labelCol={{ span: 5 }}
								wrapperCol={{ span: 12 }}
								onFinish={this.onCreate}
							>
								<div className='centralButton'>
									<Form.Item
										name='inputname'
										rules={[
											{
												required: true,
												message:
													"Please input your question",
											},
										]}
									>
										<Input
											type='textarea'
											placeholder='Question'
										/>
									</Form.Item>
								</div>
								<div className='centralButton'>
									<Form.Item>
										<Button
											onClick={onCreate}
											className='coinButton profileApply'
											type='primary'
											htmlType='submit'
										>
											Edit
										</Button>
									</Form.Item>
								</div>
							</Form>
						</div>
					</div>
				</Modal>
			</React.Fragment>
		)
	}
}

export default EditModal
